import { ProvideMenuModule } from "./provide-menu/provide-menu.module";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgxSpinnerModule } from "ngx-spinner";

import { AdSliderModule } from "./ad-slider/ad-slider.module";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HnService } from "./app.service";
import { AuthGuardService } from "./common/services/auth-guard.service";
import { AuthJWTService } from "./common/services/auth-jwt.service";
import { AuthService } from "./common/services/auth.service";
import { LoaderService } from "./common/services/loader.service";
import { RequestInterceptorService } from "./common/services/request-interceptor.service";
import { SessionService } from "./common/services/session.service";
import { StorageService } from "./common/services/storage.service";
import { UtilityService } from "./common/services/utility.service";
import { KaryakartaDashboardComponent } from "./karyakarta-dashboard/karyakarta-dashboard.component";
import { FooterComponent } from "./layout/footer/footer.component";
import { LayoutComponent } from "./layout/layout/layout.component";
import { MainComponent } from "./layout/main/main.component";
import { MenuComponent } from "./layout/menu/menu.component";
import { TopbarComponent } from "./layout/topbar/topbar.component";
import { LoginApiService } from "./login/services/login.api.service";
import { LoginService } from "./login/services/login.service";
import { MainDashboardComponent } from "./main-dashboard/main-dashboard.component";
import { PrimeNgModule } from "./prime-ng/prime-ng.module";
import { ProgramCalenderComponent } from "./program-calender/program-calender.component";
import { ReportBarChartComponent } from "./report/report-bar-chart/report-bar-chart.component";
import { ReportHeaderComponent } from "./report/report-header/report-header.component";
import { emptyValuePipe } from "./shared/Pipe/empty-value.pipe";
import { PipeModule } from "./shared/Pipe/pipe.module";
import { SharedModule } from "./shared/shared.module";
import { BirthdayCreateComponent } from "./todays-birthday/birthday-create/birthday-create.component";
import { PermissionMgmtCreateComponent } from "./UserManagement/permission-mgmt-create/permission-mgmt-create.component";
import { PermissionMgmtListComponent } from "./UserManagement/permission-mgmt-list/permission-mgmt-list.component";
import { UserProfileComponent } from "./UserManagement/user-profile/user-profile.component";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { HttpClient } from "@angular/common/http";
import { GenericModule } from "./generic/generic.module";
import { PinTableModule } from "./pin-modules/pin-table-module/pin-table.module";

// import { MultiLangModule } from "./multi-lang/multi-lang.module";
import { PermissionMgmtComponent } from "./permission/permission-mgmt/permission-mgmt.component";
import { CreateMenuComponent } from "./permission/create-menu/create-menu.component";
import { TodoService } from "./todo/todo.service";
// import { EmailViewComponent } from './email/components/email-view/email-view.component';

@NgModule({
  declarations: [
    AppComponent,
    TopbarComponent,
    MenuComponent,
    MainComponent,
    FooterComponent,
    LayoutComponent,
    PermissionMgmtCreateComponent,
    PermissionMgmtListComponent,
    UserProfileComponent,
    KaryakartaDashboardComponent,
    ProgramCalenderComponent,
    ReportHeaderComponent,
    ReportBarChartComponent,
    BirthdayCreateComponent,
    MainDashboardComponent,
    PermissionMgmtComponent,
    CreateMenuComponent,
    // EmailViewComponent,
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    PinTableModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    PrimeNgModule,
    AdSliderModule,
    PipeModule,
    SharedModule,
    GenericModule,
    FormsModule,
    ProvideMenuModule,
    NgxSpinnerModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => {
          return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
        },
        deps: [HttpClient],
      },
    }),
    // MultiLangModule,
  ],
  providers: [
    AuthService,
    AuthJWTService,
    AuthGuardService,
    LoginService,
    SessionService,
    StorageService,
    LoginApiService,
    UtilityService,
    LoaderService,
    TodoService,
    HnService,
    emptyValuePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptorService,
      multi: true,
    },
    {
      provide: "heroResolver",
      useValue: () => {},
    },
  ],

  bootstrap: [AppComponent],
})
export class AppModule {}
